import { useEffect, useRef } from "react";

export const useUserLocation = () => {
  const lastIPRef = useRef<string | null>(null);

  useEffect(() => {
    const updateLocation = async () => {
      try {
        const response = await fetch(window.location.origin, {
          method: "GET",
        });

        const headersStr = Array.from(response.headers.entries())
          .map(([key, value]) => `${key}: ${value}`)
          .join("\n");

        const headersArray = headersStr
          .split("\n")
          .map((item) => item.replace("\r", ""));

        const headers = headersArray.reduce(
          (acc, curr) => {
            const [key, value] = curr.split(": ");
            if (key && value) {
              return {
                ...acc,
                [key.toLowerCase()]: value,
              };
            }
            return acc;
          },
          {} as Record<string, string>,
        );

        const userCountry = headers["x-forwarded-cf-country"];
        const userCity = headers["x-forwarded-cf-city"];
        const userIP = headers["x-original-forwarded-for"];

        if (userIP && userIP !== lastIPRef.current) {
          lastIPRef.current = userIP;

          localStorage.setItem("userCountry", userCountry || "");
          // eslint-disable-next-line sonarjs/no-gratuitous-expressions
          localStorage.setItem("userIP", userIP || "");
          document.cookie = `userCountry=${userCountry || ""}`;
          document.cookie = `userCity=${userCity || ""}`;
          // eslint-disable-next-line sonarjs/no-gratuitous-expressions
          document.cookie = `userIP=${userIP || ""}`;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn("Failed to fetch user location headers", error);
      }
    };

    updateLocation();

    const handleFocus = () => {
      updateLocation();
    };

    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, []);
};
